module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech.5b5911a4c4b3e93da090d0e82e749e0d.png";